import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const StyledSpacer = styled.div`
  ${({ $width }) => $width !== undefined && `width: ${$width};`}
  ${({ $height }) => $height !== undefined && `height: ${$height};`}
  ${({ $width, $height }) =>
    $width && !$height ? 'display: inline-block;' : 'display: block;'}
  flex-shrink: 0;
`;

const Spacer = ({ width = 0, height = 0 }) => {
  return (
    <StyledSpacer
      $width={width}
      $height={height}
    />
  );
};

export default Spacer;
